import React from "react";
const id = Math.random().toString(36).substring(7);

export default class ScriptSlot extends React.Component {
	constructor(props, context) {
    super(props, context);
  }
  
  loadScript = () => { 
	  const existingScript = document.getElementById(id); 
	  if (!existingScript) { 
	    const script = document.createElement('script');
	    script.src = (this.props.datas && this.props.datas.ads_path ? this.props.datas.ads_path : 'https://app.viralsweep.com/vsa-widget-d38b62-87330.js?sid=87330_576309');
	    script.type='text/javascript';
	    script.id = 'script';
	    script.async=true;
	    document.body.appendChild(script); 
	  }
	};

	componentWillMount() {
		this.loadScript();
	}

  render () {
    return(
    	<React.Fragment>
    	  <div id={(this.props.datas && this.props.datas.ads_id ? this.props.datas.ads_id : "vsscript_87330_576309")} style={{/*minHeight: parseInt(this.props.datas && this.props.datas.ads_height ? this.props.datas.ads_height : "200") + 'px', minWidth: parseInt(this.props.datas && this.props.datas.ads_width ? this.props.datas.ads_width : "350") + 'px'*/}}> &nbsp; </div>
	      <React.Fragment id={id}> 
	      </React.Fragment> 
	    </React.Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/app/views/frontend/dashboard/ScriptSlot.js